import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRouteSupportHcp = ({ children }) => {
  const isAuthenticated = localStorage.getItem("supporthcpToken");
  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default PrivateRouteSupportHcp;
